// stores/dialogStore.js
import { defineStore } from 'pinia'

export const useDialogStore = defineStore('dialog', {
  state: () => ({
    isDialogVisible: false,
    title: '',
    content: '',
    positiveButtonText: 'OK',
    negativeButtonText: 'キャンセル',
    showNegativeButton: true,
    alert: false,
    small: false,
    dark: true,
    confirmResponse: false,
    // ダイアログの結果を解決するためのPromiseリゾルバー
    resolvePromise: null,
  }),

  actions: {
    async showMessageDialog(title, content) {
      this.reset()
      this.alert = false
      this.positiveButtonText = 'OK'
      this.showNegativeButton = false
      this.title = title
      this.content = content

      // ダイアログを表示
      this.isDialogVisible = true
      // 新しいPromiseを作成して返す
      return new Promise(resolve => {
        this.resolvePromise = resolve
      })
    },

    async showAlertDialog(title, content) {
      this.reset()
      this.alert = true
      this.positiveButtonText = 'OK'
      this.showNegativeButton = false
      this.title = title
      this.content = content

      // ダイアログを表示
      this.isDialogVisible = true
      // 新しいPromiseを作成して返す
      return new Promise(resolve => {
        this.resolvePromise = resolve
      })
    },

    async showConfirmDialog(title, content) {
      this.reset()
      this.title = title
      this.content = content
      this.positiveButtonText = 'OK'
      this.negativeButtonText = 'キャンセル'
      this.showNegativeButton = true
      this.isDialogVisible = true

      // 新しいPromiseを作成して返す
      return new Promise(resolve => {
        this.resolvePromise = resolve
      })
    },

    // ポジティブボタン（OK）がクリックされたときの処理
    onPositiveClick() {
      this.isDialogVisible = false

      // Promiseを解決し、trueを返す
      if (this.resolvePromise) {
        this.resolvePromise(true)
        this.resolvePromise = null
      }
    },

    // ネガティブボタン（キャンセル）がクリックされたときの処理
    onNegativeClick() {
      this.isDialogVisible = false

      // Promiseを解決し、falseを返す
      if (this.resolvePromise) {
        this.resolvePromise(false)
        this.resolvePromise = null
      }
    },

    // ダイアログが閉じられたときの処理（バックドロップクリックなど）
    onDialogClose() {
      this.isDialogVisible = false

      // Promiseを解決し、falseを返す（キャンセルと同等）
      if (this.resolvePromise) {
        this.resolvePromise(false)
        this.resolvePromise = null
      }
    },

    // ステートをリセットする
    reset() {
      this.isDialogVisible = false
      this.alert = false
      this.small = false
      this.dark = true
      this.confirmResponse = false
      // 未解決のPromiseがある場合はキャンセル扱いにする
      if (this.resolvePromise) {
        this.resolvePromise(false)
        this.resolvePromise = null
      }
    },
  },
})
